export default {
    data(){
        return {
            pagination: {
                currentPage: 1,
                pageSize: 25,
                pageSizes: [10,15,20,25,50],
                totalPage: 1,
                totalItems: null,
            },
        }
    },
    methods: {
        async checker(val){
            if(val){
              this.pagination.currentPage = 1;
            }
            await this.caller();
            this.pagination.totalItems = await this.$store.getters.getDataCount;
            this.pagination.totalPage = Math.ceil(this.pagination.totalItems/this.pagination.pageSize);
            return this.pagination.totalPage;
        },
    }
}